import React from "react";
import { navigate, Link } from "gatsby";
import Button from "../../elements/button/Button";
// import { toast } from "react-hot-toast";

import { getLocationId } from ".";
import { posthogEvents } from "@col-care/common/utilities/constants";
import {
  capturePosthogLink,
  capturePosthogEvent,
} from "@col-care/common/utilities/index";

import * as hedyStyles from "./variants/productfinder-hedy.module.css";
import * as pressStyles from "./variants/productfinder-press.module.css";
import * as tgsStyles from "./variants/productfinder-press.module.css";
import * as amberStyles from "./variants/productfinder-amber.module.css";
import * as triplesevenStyles from "./variants/productfinder-tripleseven.module.css";
import * as seedandstrainStyles from "./variants/productfinder-seedandstrain.module.css";

// const toastOpts = {
//   success: {
//     style: {
//       background: "green",
//     },
//   },
//   error: {
//     style: {
//       background: "red",
//     },
//   },
// };

const ProductFinderResults = (props) => {
  //console.log("ProductFinderResults props", props);
  const posthog = props.posthog;

  const toggleClass = (index) => {
    props.setClasses(index);
  };
  let styles;
  let theme;

  switch (props.variant) {
    case "hedy":
      styles = hedyStyles;
      theme = "hedyBtn";
      break;
    case "amber":
      styles = amberStyles;
      theme = "amber";
      break;
    case "tripleseven":
      styles = triplesevenStyles;
      theme = "tripleSeven";
      break;
    case "seedandstrain":
      styles = seedandstrainStyles;
      theme = "seedandstrain";
      break;
    case "tgs":
      styles = tgsStyles;
      theme = "tgsSelect";
      break;
    case "press":
      styles = pressStyles;
      theme = "pressBtn";
      break;
    default:
      styles = pressStyles;
      theme = "hedyBtn";
      break;
  }

  const openInNewTab = (url) => {
    // 👇️ setting target to _blank with window.open
    window.open(url, "_blank");
  };

  if (!props.apiData) {
    const sorted = props.unsortedCoordinates.sort((a, b) =>
      a.content?.state?.localeCompare(b.content?.state)
    );
    // Sort the locations based on whether the store ID matches the location ID
    const sortedLocations = props.unsortedCoordinates.slice().sort((a, b) => {
      const storeId =
        props.cartData && props.cartData.store ? props.cartData.store.id : null;
      const locationIdA = a.content.id;
      const locationIdB = b.content.id;

      // Check if the store ID matches the location ID
      const isStoreMatchA = storeId === locationIdA;
      const isStoreMatchB = storeId === locationIdB;

      // Handle the case where the store ID matches for one item and not the other
      if (isStoreMatchA !== isStoreMatchB) {
        return isStoreMatchA ? -1 : 1; // Place the matching item before the non-matching one
      }

      // Handle the case where neither or both have matching store IDs
      if (isStoreMatchA && isStoreMatchB) {
        return 0; // Keep their relative order unchanged
      }

      // If neither has a matching store ID, sort alphabetically by location content
      const locationNameA =
        a.content.brand + (a.content.nickname ? `: ${a.content.nickname}` : "");
      const locationNameB =
        b.content.brand + (b.content.nickname ? `: ${b.content.nickname}` : "");
      return locationNameA.localeCompare(locationNameB);
    });

    return (
      <ul id="locations-list">
        {sortedLocations.map((coord, index) => {
          const location = props.locationsByUrl[coord.url];
          return (
            <li
              key={index + getLocationId(coord.url)}
              id={getLocationId(coord.url)}
              className={
                props.classes == location?.url ? `${styles.active}` : null
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                props.setCurrentMarker(location);
                props.setCurrentCenter({
                  lat: location?.content?.geolocation?.lat,
                  lng: location?.content?.geolocation?.lng,
                });
                props.map.panTo({
                  lat: location?.content?.geolocation?.lat,
                  lng: location?.content?.geolocation?.lng,
                });
                // props.setZoom(7)
                toggleClass(location.url);
              }}
            >
              {props.cartData &&
                props.cartData.store &&
                props.cartData.store.id === location.content.id &&
                props.variant === "tgs" && <h5>Your Location:</h5>}
              {props.variant !== "tgs" && !location.content.website ? (
                <h4>
                  {`${location.content.brand}${
                    location.content.nickname &&
                    location.content.nickname.length > 0
                      ? ":"
                      : ""
                  } ${location.content.nickname}`}
                </h4>
              ) : (
                <Link
                  to={
                    props.variant === "tgs"
                      ? location.url
                      : location.content.website
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    const link =
                      props.variant === "tgs"
                        ? location.url
                        : location.content.website;

                    capturePosthogLink({
                      eventName: `${posthogEvents.PRODUCT_FINDER} :
                         ${posthogEvents.LOCATION_LINK_CLICKED}`,
                      title: `${location.content.brand}${
                        !!location?.content?.nickname ? ":" : ""
                      } ${location.content.nickname}`,
                      to: link,
                      posthog,
                    });
                  }}
                >
                  <h4>
                    {`${location.content.brand}${
                      !!location?.content?.nickname ? ":" : ""
                    } ${location.content.nickname}`}
                  </h4>
                </Link>
              )}
              <span>{location.content.address_1}</span>
              <span>
                {location.content.city}, {location.content.state}{" "}
              </span>
              {location.content.telephone && (
                <span>{location.content.telephone}</span>
              )}
              {props.variant === "tgs" ? (
                <div style={{ display: "flex", gap: "10px" }}>
                  {props.cartData.store.id !== location.content.id && (
                    <Button
                      theme={theme}
                      label="select this location"
                      id="select-location-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (props.cartData.store.id === null) {
                          props.cartData.store.id = location.content.id;
                          props.cartData.store.name = location.title;
                          props.cartData.store.janeId =
                            location.content.vendor_integrations.jane_rec_id;
                          props.cartData.products = [];
                          props.cartData.productsCount = 0;
                          props.doSetCartData(props.cartData);
                          const link = "/shop/" + location?.content?.id;
                          navigate(link);

                          capturePosthogLink({
                            eventName: `${posthogEvents.PRODUCT_FINDER} :
                                   ${posthogEvents.LOCATION_LINK_CLICKED}`,
                            title: `Select this location`,
                            to: link,
                            posthog,
                          });
                        } else {
                          props.setShowLocationUpdateModal(location);
                          capturePosthogEvent({
                            eventName: `${posthogEvents.PRODUCT_FINDER} : ${posthogEvents.LOCATION_CHANGE_MODAL_OPENED}`,
                            posthog,
                            databag: {
                              cartData: props?.cartData,
                            },
                          });
                        }
                      }}
                    />
                  )}

                  <Button
                    theme={`tgsSelectTransparent`}
                    label="view details"
                    onClick={(e) => {
                      e.stopPropagation();
                      const link = `/locations/${location.content.id}`;
                      navigate(link);
                      capturePosthogLink({
                        eventName: `${posthogEvents.PRODUCT_FINDER}: ${posthogEvents.LOCATION_LINK_CLICKED}`,
                        title: `View Details`,
                        to: link,
                        posthog,
                      });
                    }}
                  />
                </div>
              ) : (
                <Button
                  theme={theme}
                  label="directions"
                  onClick={(e) => {
                    e.stopPropagation();
                    const link = `${location?.content?.website}`;

                    capturePosthogLink({
                      eventName: `${posthogEvents.PRODUCT_FINDER}: ${posthogEvents.LOCATION_LINK_CLICKED}`,
                      title: `Directions`,
                      to: link,
                      posthog,
                    });
                    openInNewTab(link);
                  }}
                />
              )}
            </li>
          );
        })}
      </ul>
    );
  }

  return (
    <ul id="locations-list">
      {Object.keys(props.topThreeStores).map((key) => {
        const coord = props.topThreeStores[key];
        const location = props.locationsByUrl[coord.url];
        return (
          <li
            id={getLocationId(coord.url)}
            key={getLocationId(coord.url)}
            className={
              props.classes == location?.url ? `${styles.active}` : null
            }
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.setCurrentMarker(location);
              props.setCurrentCenter({
                lat: location?.content?.geolocation?.lat,
                lng: location?.content?.geolocation?.lng,
              });
              props.map.panTo({
                lat: location?.content?.geolocation?.lat,
                lng: location?.content?.geolocation?.lng,
              });
              props.setZoom(7);
              props.setClasses(location?.url);
            }}
          >
            <h4>{`${location.content.brand}${
              !!location?.content?.nickname ? ":" : ""
            } ${location.content.nickname}`}</h4>
            <span>{location.content.address_1}</span>
            <span>
              {location.content.city}, {location.content.state}{" "}
            </span>
            {location.content.telephone && (
              <span>{location.content.telephone}</span>
            )}
            {props.variant === "tgs" ? (
              <div className={styles.location_button_container}>
                <Button
                  theme={theme}
                  label="shop this location"
                  id="select-location-button"
                  onClick={(e) => {
                    e.stopPropagation();

                    if (props.cartData.store.id === null) {
                      props.cartData.store.id = location.content.id;
                      props.cartData.store.name = location.title;
                      props.cartData.store.janeId =
                        location.content.vendor_integrations.jane_rec_id;
                      props.cartData.products = [];
                      props.cartData.productsCount = 0;
                      props.doSetCartData(props.cartData);

                      const link = "/shop/" + location?.content?.id;

                      navigate(link);
                      capturePosthogLink({
                        eventName: `${posthogEvents.PRODUCT_FINDER}: ${posthogEvents.LOCATION_LINK_CLICKED}`,
                        title: `Shop this location`,
                        to: link,
                        posthog,
                      });
                    } else {
                      props.setShowLocationUpdateModal(location);
                      capturePosthogEvent({
                        eventName: `${posthogEvents.PRODUCT_FINDER} : ${posthogEvents.LOCATION_CHANGE_MODAL_OPENED}`,
                        posthog,
                        databag: {
                          cartData: props?.cartData,
                        },
                      });
                    }
                  }}
                />
                <Button
                  theme={`tgsSelectTransparent`}
                  label="View Details"
                  onClick={(e) => {
                    e.stopPropagation();
                    const link = location.url;

                    navigate(link);
                    capturePosthogLink({
                      eventName: `${posthogEvents.PRODUCT_FINDER}: ${posthogEvents.LOCATION_LINK_CLICKED}`,
                      title: `View Details`,
                      to: link,
                      posthog,
                    });
                  }}
                />
              </div>
            ) : (
              <Button
                theme={theme}
                label="directions"
                onClick={(e) => {
                  e.stopPropagation();
                  const link = `${location?.content?.website}`;

                  capturePosthogLink({
                    eventName: `${posthogEvents.PRODUCT_FINDER}: ${posthogEvents.LOCATION_LINK_CLICKED}`,
                    title: `Directions`,
                    to: link,
                    posthog,
                  });
                  openInNewTab(link);
                }}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ProductFinderResults;
